module.exports = __webpack_public_path__ + "static/media/bell.9342972d.svg";